/** Build-time configuration from Vite env files. Identifiers only. docs/BUILD.md §12. */
export const config = {
  tenantId: import.meta.env.VITE_TENANT_ID as string,
  clientId: import.meta.env.VITE_CLIENT_ID as string,
  apiScope: import.meta.env.VITE_API_SCOPE as string,
  apiBaseUrl: ((import.meta.env.VITE_API_BASE_URL as string) ?? '').replace(/\/+$/, ''),
  authDisabled: import.meta.env.VITE_AUTH_DISABLED === 'true',
} as const;

for (const [k, v] of Object.entries(config)) {
  if (v === undefined || v === '') {
    if (k === 'apiBaseUrl') continue; // same-origin is allowed
    throw new Error(`Missing web configuration: ${k}`);
  }
}
